import { Box, Typography } from '@mui/material'
import softwares_bg from 'src/assets/softwares_bg.webp'
import SystemSolutionsCard from 'src/components/SystemSolutions/SystemSolutionsCard'
import { developedSoftwares } from 'src/components/SystemSolutions/enums'

const Softwares = () => {
  return (
    <Box>
      <Box
        sx={{
          height: { xs: 'fit-content', md: '300px' },
          backgroundImage: `url(${softwares_bg})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundBlendMode: 'overlay',
          backgroundColor: '#444444',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 6, md: 0 },
        }}
      >
        <Typography
          variant="h4"
          fontWeight={600}
          fontStyle="italic"
          color="#f4f4f4"
          textAlign="center"
          sx={{ width: { xs: '80%', sm: '90%', md: '700px' } }}
        >
          Software Solutions
        </Typography>
      </Box>
      <Box sx={{ py: 5 }}>
        <Typography
          variant="h5"
          fontWeight="500"
          sx={{
            mb: 5,
            textAlign: 'center',
            borderBottom: `2px solid #000`,
            width: 'fit-content',
            mx: 'auto',
          }}
        >
          System software developed
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
          {developedSoftwares.map((software, index) => (
            <SystemSolutionsCard {...software} key={index} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default Softwares
